module.exports = __webpack_public_path__ + "static/jiva4-df40463030beb2ef687d468b7a6eb265.png";